// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const ClaimForApprovalContributions = t.struct({
    company: t.maybe(t.Number),
    customer: t.maybe(t.Number),
    dealer: t.maybe(t.Number),
    total: t.maybe(t.Number)
}, {
    name: 'ClaimForApprovalContributions',
    strict: true
});

export const getDefaultState = () => new ClaimForApprovalContributions({
    company: 0,
    customer: 0,
    dealer: 0,
    total: 0
});

ClaimForApprovalContributions.prototype.calculateTotal = function calculateTotal() {

    const company = this.company ? this.company : 0;
    const customer = this.customer ? this.customer : 0;
    const dealer = this.dealer ? this.dealer : 0;

    return company + customer + dealer;

};

export default ClaimForApprovalContributions;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-for-approval-contributions.js